import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-340cdee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["d", "stroke", "stroke-width", "stroke-dasharray", "marker-start", "marker-end"]

import { computed, PropType } from 'vue'
import { PPTLineElement } from '@/types/slides'
import { getLineElementPath } from '@/utils/element'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'

import LinePointMarker from './LinePointMarker.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLineElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTLineElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const svgWidth = computed(() => {
  const width = Math.abs(props.elementInfo.start[0] - props.elementInfo.end[0])
  return width < 24 ? 24 : width
})
const svgHeight = computed(() => {
  const height = Math.abs(props.elementInfo.start[1] - props.elementInfo.end[1])
  return height < 24 ? 24 : height
})

const lineDashArray = computed(() => props.elementInfo.style === 'dashed' ? '10, 5' : '0, 0')

const path = computed(() => {
  return getLineElementPath(props.elementInfo)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-line",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "element-content",
      style: _normalizeStyle({ filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '' })
    }, [
      (_openBlock(), _createElementBlock("svg", {
        overflow: "visible",
        width: _unref(svgWidth),
        height: _unref(svgHeight)
      }, [
        _createElementVNode("defs", null, [
          (__props.elementInfo.points[0])
            ? (_openBlock(), _createBlock(LinePointMarker, {
                key: 0,
                id: __props.elementInfo.id,
                position: "start",
                type: __props.elementInfo.points[0],
                color: __props.elementInfo.color,
                baseSize: __props.elementInfo.width
              }, null, 8, ["id", "type", "color", "baseSize"]))
            : _createCommentVNode("", true),
          (__props.elementInfo.points[1])
            ? (_openBlock(), _createBlock(LinePointMarker, {
                key: 1,
                id: __props.elementInfo.id,
                position: "end",
                type: __props.elementInfo.points[1],
                color: __props.elementInfo.color,
                baseSize: __props.elementInfo.width
              }, null, 8, ["id", "type", "color", "baseSize"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("path", {
          d: _unref(path),
          stroke: __props.elementInfo.color,
          "stroke-width": __props.elementInfo.width,
          "stroke-dasharray": _unref(lineDashArray),
          fill: "none",
          "marker-start": __props.elementInfo.points[0] ? `url(#${__props.elementInfo.id}-${__props.elementInfo.points[0]}-start)` : '',
          "marker-end": __props.elementInfo.points[1] ? `url(#${__props.elementInfo.id}-${__props.elementInfo.points[1]}-end)` : ''
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    ], 4)
  ], 4))
}
}

})